export default "__VITE_ASSET__a2ae3c2d__"